<div id="myContainer" [ngClass]="device === 'desktop' ? 'desktop-top-margin' : ''">
  <div class="device" [ngClass]="deviceClass">
    <div
      class="device-frame"
      id="device-frame"
      [ngClass]="device === 'mobile' ? 'mobile-device-frame' : ''"
      #element
    >
      <div myCdkOverlayContainer></div>
      <cdk-virtual-scroll-viewport
        #viewport
        (scroll)="onScroll()"
        id="web-app"
        class="device-screen component-wrapper"
        [ngClass]="
          device === 'mobile' ? 'device-screen component-wrapper' : 'canvas-wrapper custom-scrollbar'
        "
        appendOnly
        itemSize="1"
        style="max-height: 100vh"
      >
        <div [ngClass]="device === 'mobile' ? 'phone-holder' : ''">
          <ng-container #container></ng-container>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>

  <finxone-workflow-frontend-image-upload-popup
    [popupSetting]="popupSettings"
  ></finxone-workflow-frontend-image-upload-popup>
</div>
